module.exports = __webpack_public_path__ + "img/IMG_20220207_142529.753b7e69.jpg";